//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import userHeader from '~/components/login/userHeader.vue'
import userCountry from '~/components/login/userCountry.vue'
import wikiGeet from '~/components/common/wikiGeet.vue'
import userVerificacode from '~/components/login/userVerificacode.vue'
import userVoicevercode from '~/components/login/userVoicevercode.vue'
import userThreparty from '~/components/login/userThreparty.vue'
import userGraphical from '~/components/login/userGraphical.vue'
import { assign } from '~/assets/js/utils.js'
export default {
  components: {
    'user-header': userHeader,
    'user-country': userCountry,
    'wiki-geet': wikiGeet,
    'user-verificacode': userVerificacode,
    'user-voicevercode': userVoicevercode,
    'user-threparty': userThreparty,
    'user-graphical': userGraphical
  },
  props: {
    phone: {
      // 手机号
      type: [Number, String],
      default: ''
    },
    verifCode: {
      // 验证码
      type: String,
      default: ''
    },
    requestId: {
      // 极验requestId
      type: String,
      default: ''
    }
  },
  data () {
    return {
      firstLoad: true, // 是否为首次加载该组件
      switchingState: 1, // 1为电子邮箱，2为创建密码，3为设置基本信息，4为身份选择，5为手机，6为验证码
      simplePsword: false, // 密码过于简单，重新输入
      // 电子邮箱
      emailNumber: false, // 电子邮箱漂浮状态
      clearButton: false, // 清空
      pasclearButton: false, // 重新输入密码清空
      phoneLoading: false, // 加载中动效
      // 创建密码
      passwordState: false, // 密码字样漂浮状态
      oneseyes: false, // 密码输入框type
      // 基本信息
      genderState: 2, // 性别：1为男，0为女
      nickName: false, // 昵称字样漂浮状态
      // 过于简单，重新输入
      resetSte: false, // 密码字样漂浮状态
      // 身份选择
      identity: [
        {
          img: 'https://resources.interface003.com/web20/img/login/trader-female.png',
          name: this.$t('22555'),
          type: 900
        }, // 交易者
        {
          img: 'https://resources.interface003.com/web20/img/login/Image.png',
          name: this.$t('22556'),
          type: 1200
        }, // 分析师
        {
          img: 'https://resources.interface003.com/web20/img/login/Image2.png',
          name: this.$t('22557'),
          type: 600
        }, // 从业者
        {
          img: 'https://resources.interface003.com/web20/img/login/Image3.png',
          name: 'IB',
          type: 300
        },
        {
          img: 'https://resources.interface003.com/web20/img/login/Image4.png',
          name: this.$t('19412'),
          type: 100
        } // 交易商
      ],
      identitySelected: '', // 身份选中
      // 手机
      roTade: false, // 国家下拉框
      phoneSize: false, // 手机号字样漂浮
      showDrag: false, // 极验
      // 绑定数值
      registerInit: {
        emailamobiledis: '', // 验证码传值展示
        mailVal: '', // 电子邮箱绑定
        isemailreg: null, // 邮箱是否注册
        setPassword: '', // 密码绑定
        errPassword: '', // 密码错误提示
        nickVal: '', // 昵称绑定
        nickError: '', // 昵称错误提示
        phone: '', // 手机号绑定
        smsCode: '', // 验证码
        formatError: '', // 手机号错误提示
        mailError: '', // 邮箱错误提示
        isregistered: null, // 该手机号是否注册
        email: '', // 该手机号是否绑定邮箱
        requestId: '', // 验证码发送后的requestId
        emailphone: null, // email为邮箱，phone为手机号
        tripartite: null, // 三方注册判断值，email为邮箱验证码，phone为手机验证码
        emailSms: '', // 三方使用邮箱验证码
        phoneSms: '', // 三方使用手机验证码
        // 重新输入密码
        resetpasswordTet: '', // 头部绑定
        resetSetpassword: '' // 密码绑定
      },
      // 验证码
      voiceState: true, // 是否展示语音验证
      countOrnot: true, // 是否展示倒计时
      isVercode: false, // 是否校验验证码
      fingerprint: this.$cookies.get('wiki-bfp'), // 浏览器指纹
      verificationCode: 1, // 1为获取手机验证码，2为获取语音验证码
      canIskip: false // 是否出现跳过
    }
  },
  computed: {
    // 小标题
    title () {
      if (this.switchingState == 1)
        return this.$route.query?.type == 'register'
          ? this.$t('22558')
          : this.$t('22512')
      else if (this.switchingState == 2) return this.$t('22559') // 创建密码
      else if (this.switchingState == 3) return this.$t('22560') // 设置基本信息
      else if (this.switchingState == 4) return this.$t('22561') // 选择您的角色
      else if (this.switchingState == 5) return this.$t('22562') // 手机
      else return this.$t('22512') // 注册
    },
    // 面包屑导航——首页
    breadHost () {
      return this.$store.getters.breadHome
    },
    // 完整的域名
    fullDomain () {
      return this.$store.state.fullHost
    },
    // 手机号相关信息（国旗、手机区号、手机号等）
    phoneCode () {
      return this.$store.state?.phoneInfo || {}
    }
  },
  watch: {
    // 监听国家下拉框
    roTade (newV) {
      if (!newV || !this.firstLoad) return false // 收起或非首次展开下拉框时，不执行后续操作
      this.firstLoad = false // 当首次展开下拉框时，需要执行以下操作，后续无需执行
      this.$nextTick(() => {
        this.$refs?.userCountry?.getHeight()
      })
    },
    // 电子邮箱绑定
    'registerInit.mailVal' (val) {
      if (val && this.switchingState == 1) {
        const reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
        if (reg.test(val)) this.clearButton = true
        else this.clearButton = false
      } else if (!val) this.clearButton = false
    },
    // 密码绑定
    'registerInit.setPassword' (val) {
      if (val && this.switchingState == 2) this.clearButton = true
      else if (!val) {
        this.clearButton = false
        assign(this.registerInit, { errPassword: '' }) // 错误提示为空
      }
    },
    // 密码简单密码绑定
    'registerInit.resetSetpassword' (val) {
      if (val) this.pasclearButton = true
      else if (!val) {
        this.pasclearButton = false
        assign(this.registerInit, { errPassword: '' }) // 错误提示为空
      }
    },
    // 昵称绑定
    'registerInit.nickVal' (val) {
      if (val) this.clearButton = true
      else if (!val) this.clearButton = false
    },
    // 手机号绑定
    'registerInit.phone' (val) {
      if (val && this.switchingState == 5) this.clearButton = true
      else if (!val) {
        this.clearButton = false
        assign(this.registerInit, { formatError: '' }) // 错误提示为空
      }
    }
  },
  mounted () {
    document.addEventListener('click', this.coutryClose)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.coutryClose)
  },
  methods: {
    // 更换手机区号
    countryChangeFn (obj = {}) {
      this.$store.commit('setVal', { phoneInfo: obj })
      this.roTade = false
    },
    // 极验错误
    geetError () {
      this.showDrag = false // 关闭极验框
      this.switchingState = 8 // 展示图形验证码
    },
    // 图形验证成功后发送验证码
    async setVercode (data = '') {
      const { phone = '', emailphone = '' } = this.registerInit
      if (!phone) return false
      assign(this.registerInit, { emailamobiledis: phone }) // 展示为手机号
      if (emailphone == 'register')
        assign(this.registerInit, { tripartite: 'phone' })
      this.showDrag = false // 隐藏拖拽框
      try {
        console.log(11111, '1/2')
        // const { succeed = false, extra = '', result = {} } = await this.$api.login.userVercode({ areaCode: this.phoneCode?.code, phone, languageCode: this.currLangCode(), msgType: 0, smsBusinessType: 1, applicationType: 7, GeetestValidate: '', GeetestChallenge: '', graphCode: data }) // 发送验证码/语音验证码
        // if (!succeed) return this.$toast.error(extra) // 数据错误
        // assign(this.registerInit, { requestId: result?.requestid })
        // this.switchingState = 6 // 跳转验证码

        const res = await this.$api.common
          .v3Client(
            {
              Routes: 'usercenter$sendcodegeettest4'
            },
            {
              areaCode: this.phoneCode?.code,
              phone,
              languageCode: this.currLangCode(),
              msgType: 0,
              userId: this.userId,
              smsBusinessType: 1,
              applicationType: 7,
              GeetestValidate: data.geetest_validate,
              GeetestChallenge: data.geetest_challenge,
              captcha_output: data.captcha_output,
              lot_number: data.lot_number,
              pass_token: data.pass_token,
              gen_time: data.gen_time
            }
          )
          .catch(() => {
            console.log('sendcodegeettest4')
          })

        const rest = res?.usercenter?.sendcodegeettest4
        console.log('rest::: ', rest)
        if (rest?.success) {
          assign(this.registerInit, { requestId: rest?.requestid })
          this.switchingState = 6 // 跳转验证码
        } else {
          return this.$toast.error(rest?.extra || 'error')
        }
      } catch (err) {}
    },
    // 语音获取验证码
    voiceTran () {
      this.countOrnot = false // 展示获取验证码
      this.switchingState = 6 // 修改为验证码弹框
      this.verificationCode = 2 // 修改为语音验证码获取
      this.$nextTick(() => {
        this.$refs?.userverificacode?.getweebgeet()
      })
    },
    // 语音获取验证码
    voiceVerification () {
      this.verificationCode = 2 // 修改为语音验证码获取
      this.switchingState = 7 // 修改为手机号弹框
    },
    // 语音获取取消
    voiceClose () {
      this.countOrnot = false // 取消倒计时
      this.switchingState = 6 // 跳转为验证码
    },
    // 再次获取验证码
    getPhonecode (data = {}) {
      this.countOrnot = true // 开启倒计时
      const { emailphone = '', tripartite = '' } = this.registerInit
      if (emailphone == 'phone') {
        this.switchingState = 1 // 切换为邮箱验证码
        this.verifyMailbox()
      } else if (emailphone == 'email') this.sendVCode(data)
      else if (emailphone == 'register') {
        if (tripartite == 'email') {
          this.switchingState = 1 // 切换为邮箱验证码
          this.verifyMailbox()
        } else if (tripartite == 'phone') this.sendVCode(data)
      }
    },
    // 验证码成功之后登录
    async getUsertion (code = '') {
      assign(this.registerInit, { smsCode: code }) // 验证码赋值
      const {
        emailphone = '',
        isemailreg = '',
        mailVal = '',
        setPassword = '',
        tripartite = '',
        isregistered = '',
        phone = ''
      } = this.registerInit
      if (emailphone == 'phone') {
        // 手机注册，邮箱发送验证码
        if (isemailreg) {
          // 判断该邮箱是否注册
          try {
            const {
              succeed = false,
              extra = '',
              result = {}
            } = await this.$api.login.userBindphone({
              email: mailVal,
              emailCode: code,
              areaCode: this.phoneCode?.code,
              phone: this.phone,
              password: setPassword,
              languagecode: this.currLangCode(),
              applicationtype: 7,
              platformtype: 0
            })
            if (!succeed) return this.$toast.error(extra) // 数据错误
            this.accessCookie(result)
          } catch (err) {}
        }
      }
      if (emailphone == 'register') {
        // 三方注册，邮箱发送验证码，邮箱已注册流程
        if (tripartite == 'email') {
          assign(this.registerInit, { emailSms: code }) // 邮箱验证码赋值
          try {
            const {
              succeed = false,
              extra = '',
              result = {}
            } = await this.$api.login.userVerifymail({
              Email: mailVal,
              Code: code,
              ApplicationType: 7,
              CountryCode: this.phoneCode?.countryCode,
              LanguageCode: this.currLangCode()
            }) // 校验验证码是否正确
            if (!succeed) return this.$toast.error(extra) // 数据错误
            assign(this.registerInit, { requestId: result?.requestId })
            this.thirdParty()
          } catch (err) {}
        } else if (tripartite == 'phone') {
          assign(this.registerInit, { phoneSms: code }) // 三方手机验证码赋值
          if (isregistered) this.thirdParty() // 判断该手机号是否注册
          else {
            // 校验验证码是否正确
            try {
              const { succeed = false, extra = '' } =
                await this.$api.login.userVerifysms({
                  AreaCode: this.phoneCode?.code,
                  PhoneNumber: phone,
                  Smscode: code,
                  ApplicationType: 7,
                  ValidateSmsCodeType: 3,
                  LanguageCode: this.currLangCode()
                })
              if (!succeed) return this.$toast.error(extra) // 数据错误
              this.switchingState = 3 // 跳转为性别选择
            } catch (err) {}
          }
        }
      }
      if (emailphone == 'email') {
        // 邮箱注册，手机发送验证码
        if (isregistered) {
          // 判断该手机号是否注册
          try {
            const {
              succeed = false,
              extra = '',
              result = {}
            } = await this.$api.login.userMobilechange({
              email: mailVal,
              smsCode: code,
              areaCode: this.phoneCode?.code,
              phone,
              password: setPassword,
              languagecode: this.currLangCode(),
              applicationtype: 7,
              platformtype: 0
            })
            if (!succeed) return this.$toast.error(extra) // 数据错误
            this.accessCookie(result)
          } catch (err) {}
        } else {
          // 校验验证码是否正确
          try {
            const { succeed = false, extra = '' } =
              await this.$api.login.userVerifysms({
                AreaCode: this.phoneCode?.code,
                PhoneNumber: phone,
                Smscode: code,
                ApplicationType: 7,
                ValidateSmsCodeType: 3,
                LanguageCode: this.currLangCode()
              })
            if (!succeed) return this.$toast.error(extra) // 数据错误
            this.switchingState = 3 // 跳转为性别选择
          } catch (err) {}
        }
      }
    },
    // 三方换绑
    async thirdParty () {
      const {
        id = '',
        name = '',
        img = '',
        logintype = ''
      } = this.$route?.query
      const {
        mailVal = '',
        emailSms = '',
        phoneSms = '',
        phone = '',
        setPassword = ''
      } = this.registerInit
      try {
        const {
          succeed = false,
          extra = '',
          result = {}
        } = await this.$api.login.userChangebinding({
          openId: id,
          accountNick: name,
          accountHead: img,
          accountType: logintype,
          email: mailVal,
          emailcode: emailSms,
          smscode: phoneSms,
          areacode: this.phoneCode?.code,
          phone,
          password: setPassword,
          languageCode: this.currLangCode()
        })
        if (!succeed) return this.$toast.error(extra) // 数据错误
        this.accessCookie(result)
      } catch (err) {}
    },
    // 点击非组件区域关闭下拉框
    coutryClose (e = {}) {
      if (!this.$el.contains(e?.target)) this.roTade = false
    },
    // 清除按钮
    close () {
      assign(this.registerInit, { phone: '', formatError: '' }) // 手机输入内容为空/手机错误提示为空
      this.phoneSize = this.phoneLoading = false // 请输入手机号样式为false，加载动画为false
    },
    // 下一步/登录
    logoIn () {
      if (!this.clearButton) return false
      const {
        mailVal = '',
        setPassword = '',
        nickVal = '',
        phone = '',
        emailphone = ''
      } = this.registerInit
      if (this.switchingState == 1 && mailVal != '') {
        this.verifyMailbox()
      } else if (this.switchingState == 2 && setPassword != '') {
        if (setPassword?.length < 6 || setPassword?.length > 20)
          return (this.registerInit.errPassword = this.$t('22563'))
        assign(this.registerInit, { errPassword: '' })
        if (this.phone) this.samePassword() // 如果为手机注册
        else {
          this.switchingState = 5 // 跳转为手机获取验证码
          this.clearButton = false // 清空按钮样式
        }
      } else if (
        this.switchingState == 3 &&
        (!nickVal || this.genderState == 2)
      ) {
        assign(this.registerInit, { nickError: this.$t('22564') })
      } else if (this.switchingState == 3 && nickVal != '') {
        assign(this.registerInit, { nickError: '' })
        this.switchingState = 4
      } else if (this.switchingState == 5 && phone != '') {
        this.samePassword()
      } else if (this.switchingState == 4 && !this.identitySelected) {
        assign(this.registerInit, { nickError: this.$t('22565') }) // 请选择角色
      } else if (this.switchingState == 4 && this.identitySelected) {
        // 身份选择
        if (emailphone == 'phone') this.phoneRegister()
        else if (emailphone == 'email') this.emailRegister()
        else if (emailphone == 'register') this.tripartiteRegister()
      }
    },
    async samePassword () {
      const {
        resetSetpassword = '',
        phone = '',
        setPassword = ''
      } = this.registerInit
      if (resetSetpassword)
        assign(this.registerInit, { setPassword: resetSetpassword })
      try {
        // 如果重置密码输入则赋值到注册密码里
        const { succeed = false, extra = '' } =
          await this.$api.login.userSamepassword({
            phone: this.phone || phone,
            passWord: setPassword,
            languageCode: this.currLangCode(),
            areaCode: this.phoneCode?.code
          })
        if (!succeed && this.phone) {
          assign(this.registerInit, { errPassword: extra })
          return false
        } else if (!succeed) {
          assign(this.registerInit, { resetpasswordTet: extra })
          this.simplePsword = true // 弹出重新输入密码
          return false
        }
        if (this.phone) {
          this.simplePsword = false // 弹出重新输入密码
          this.switchingState = 3 // 跳转为设置基本信息
          this.clearButton = false // 清空按钮样式
        } else {
          this.simplePsword = false // 弹出重新输入密码
          this.getVercode() // 获取验证码
        }
      } catch (err) {}
    },
    // 邮箱注册
    async emailRegister () {
      if (this.phoneLoading) return false // 接口请求中，不执行后续操作
      this.phoneLoading = true // 请求开始
      const { ip = '' } = this.$store.state
      const { code = '', flag = '', countryCode = '' } = this.phoneCode
      const {
        phone = '',
        nickVal = '',
        mailVal = '',
        setPassword = '',
        requestId = '',
        smsCode = ''
      } = this.registerInit
      try {
        const {
          succeed = false,
          extra = '',
          result = {}
        } = await this.$api.login.userEmailregister({
          areaCode: code,
          areaFlag: flag,
          phone,
          lastname: nickVal,
          email: mailVal,
          identityType: this.identitySelected,
          password: setPassword,
          sex: this.genderState,
          isSkip: 0,
          requestId,
          deviceInformation: 'web',
          version: 124,
          registrationPlatform: 0,
          deviceCode: this.fingerprint,
          msgCode: smsCode,
          isContainIM: 1,
          userFirstName: nickVal,
          registrationType: 311,
          applicationType: 7,
          countryCode,
          languageCode: this.currLangCode(),
          ip
        })
        this.phoneLoading = false // 请求结束
        if (!succeed) return this.$toast.error(extra) // 数据错误
        this.accessCookie(result)
      } catch (err) {}
      this.phoneLoading = false // 请求结束
    },
    // 手机注册
    async phoneRegister () {
      if (this.phoneLoading) return false // 接口请求中，不执行后续操作
      this.phoneLoading = true // 请求开始
      const { ip = '' } = this.$store.state
      const { code = '', flag = '', countryCode = '' } = this.phoneCode
      const { nickVal = '', mailVal = '', setPassword = '' } = this.registerInit
      try {
        const {
          succeed = false,
          extra = '',
          result = {}
        } = await this.$api.login.userEmailregister({
          areaCode: code,
          areaFlag: flag,
          phone: this.phone,
          lastname: nickVal,
          email: mailVal,
          identityType: this.identitySelected,
          password: setPassword,
          sex: this.genderState,
          isSkip: 0,
          requestId: this.requestId,
          deviceInformation: 'web',
          version: 124,
          registrationPlatform: 0,
          deviceCode: this.fingerprint,
          msgCode: this.verifCode,
          isContainIM: 1,
          userFirstName: nickVal,
          registrationType: 311,
          applicationType: 7,
          countryCode,
          languageCode: this.currLangCode(),
          ip
        })
        this.phoneLoading = false // 请求结束
        if (!succeed) return this.$toast.error(extra) // 数据错误
        this.accessCookie(result)
      } catch (err) {}
      this.phoneLoading = false // 请求结束
    },
    // 三方注册
    async tripartiteRegister () {
      if (this.phoneLoading) return false // 接口请求中，不执行后续操作
      this.phoneLoading = true // 请求开始
      const { id = '', name = '', img = '', logintype = '' } = this.$route.query
      const { ip = '' } = this.$store.state
      const { code = '', flag = '', countryCode = '' } = this.phoneCode
      const {
        phone = '',
        nickVal = '',
        mailVal = '',
        setPassword = '',
        requestId = '',
        phoneSms = ''
      } = this.registerInit
      try {
        const {
          succeed = false,
          extra = '',
          result = {}
        } = await this.$api.login.userThirdregistration({
          openId: id,
          unionId: id,
          accountNick: name,
          accountHead: img,
          isReplace: true,
          accountType: logintype,
          registrationPlatform: 0,
          languageCode: this.currLangCode(),
          areaCode: code,
          areaFlag: flag,
          phone,
          lastname: nickVal,
          email: mailVal,
          identityType: this.identitySelected,
          password: setPassword,
          sex: this.genderState,
          isSkip: 0,
          requestId,
          deviceInformation: 'web',
          version: 124,
          deviceCode: this.fingerprint,
          inviteCode: '',
          msgCode: phoneSms,
          isContainIM: 0,
          userFirstName: nickVal,
          friendsharecontent: '',
          registrationType: 311,
          applicationType: 7,
          countryCode,
          ip
        })
        this.phoneLoading = false // 请求结束
        if (!succeed) return this.$toast.error(extra) // 数据错误
        this.accessCookie(result)
      } catch (err) {}
      this.phoneLoading = false // 请求结束
    },
    // 校验邮箱
    async verifyMailbox () {
      const { mailVal = '' } = this.registerInit
      try {
        const {
          succeed = false,
          extra = '',
          result = false
        } = await this.$api.login.userMailregis({
          email: mailVal,
          languageCode: this.currLangCode()
        })
        if (!succeed) return (this.registerInit.mailError = extra) // 数据错误
        assign(this.registerInit, { isemailreg: result }) // 邮箱是否注册
        this.isRegistration(result) // 判断是否为邮箱注册
      } catch (err) {}
    },
    // 邮箱注册，手机注册切换逻辑
    async isRegistration (result = '') {
      const { type = '' } = this.$route.query
      const { mailVal = '' } = this.registerInit
      if (result) {
        // 邮箱已注册
        if (this.phone || type == 'register') {
          // 判断是否是登录注册
          const emailphone = type == 'register' ? 'register' : 'phone'
          assign(this.registerInit, { emailphone }) // 为手机号注册
          if (emailphone == 'register')
            assign(this.registerInit, { tripartite: 'email' }) // 三方注册为邮箱验证码
          this.switchingState = 6 // 跳转为验证码弹框
          this.voiceState = false // 语音验证码不展示
          assign(this.registerInit, { emailamobiledis: mailVal }) // 展示为邮箱
          const { succeed = false, extra = '' } =
            await this.$api.login.userMailcode({
              email: mailVal,
              languageCode: this.currLangCode(),
              emailType: 0,
              applicationType: 7,
              version: 124
            })
          if (!succeed) return extra // 数据错误
        } else
          assign(this.registerInit, {
            emailphone: 'email',
            mailError: this.$t('22566')
          }) // 邮箱已被注册
      } else {
        // 邮箱未注册
        if (this.phone)
          assign(this.registerInit, {
            emailphone: 'phone'
          }) // 判断是否是登录注册
        else if (type == 'register')
          assign(this.registerInit, { emailphone: 'register' }) // 为手机号注册
        else assign(this.registerInit, { emailphone: 'email' })
        assign(this.registerInit, { mailError: '' }) // 错误提示取消
        this.switchingState = 2 // 跳到输入密码
        this.clearButton = false // 取消按钮样式
      }
    },
    // 获取验证码
    getVercode () {
      const { phone = '' } = this.registerInit
      if (!phone) return (this.registerInit.formatError = this.$t('22520'))
      const myreg =
        this.phoneCode?.code != '0086'
          ? /^.{5,20}$/
          : /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (myreg.test(phone)) {
        assign(this.registerInit, { formatError: '' }) // 验证成功则清空错误消息
        this.numberRis()
      } else assign(this.registerInit, { formatError: this.$t('22521') })
    },
    // 手机校验是否注册之后是否发送验证码国内国际逻辑
    async numberRis () {
      const { phone = '' } = this.registerInit
      if (!phone) return false
      try {
        const {
          succeed = false,
          extra = '',
          result = {}
        } = await this.$api.login.userCheckphone({
          areaCode: this.phoneCode.code,
          phoneNumber: phone
        }) // 校验手机号是否注册
        console.log('这里11')
        if (!succeed) return this.$toast.error(extra) // 数据错误
        assign(this.registerInit, {
          isregistered: result?.isregister,
          email: result?.email
        }) // 该手机号是否注册，该手机号是否绑定邮箱
        this.voiceState = true
        if (result?.isregister) this.showDrag = true // 手机注册过则出现极验
        else if (this.phoneCode?.code == '0086') {
          // 手机未注册，为0086则出现极验
          this.canIskip = true // 未注册且为0086则出现跳过
          this.showDrag = true // 极验框展示
        } else this.switchingState = 3 // 不为0086则直接跳注册流程，跳转为性别选择
      } catch (err) {}
    },
    // 验证码登录极验
    async sendVCode (data = {}) {
      const { phone = '', emailphone = '' } = this.registerInit
      if (!phone) return false
      this.showDrag = false // 隐藏拖拽框
      assign(this.registerInit, { emailamobiledis: phone }) // 展示为手机号
      if (emailphone == 'register')
        assign(this.registerInit, { tripartite: 'phone' })
      try {
        console.log(222222, '1/2')
        // const { succeed = false, extra = '', result = {} } = await this.$api.login.userVercode({ areaCode: this.phoneCode?.code, phone, languageCode: this.currLangCode(), msgType: this.verificationCode == 1 ? 0 : 1, smsBusinessType: 1, applicationType: 7, GeetestValidate: data.geetest_validate, GeetestChallenge: data.geetest_challenge }) // 发送验证码/语音验证码
        // if (!succeed) return this.$toast.error(extra) // 数据错误
        // assign(this.registerInit, { requestId: result?.requestid })
        // this.verificationCode = 1
        // this.switchingState = 6 // 跳转验证码

        const res = await this.$api.common
          .v3Client(
            {
              Routes: 'usercenter$sendcodegeettest4'
            },
            {
              areaCode: this.phoneCode?.code,
              phone,
              languageCode: this.currLangCode(),
              msgType: 0,
              userId: this.userId,
              smsBusinessType: 1,
              applicationType: 7,
              GeetestValidate: data.geetest_validate,
              GeetestChallenge: data.geetest_challenge,
              captcha_output: data.captcha_output,
              lot_number: data.lot_number,
              pass_token: data.pass_token,
              gen_time: data.gen_time
            }
          )
          .catch(() => {
            console.log('sendcodegeettest4')
          })

        const rest = res?.usercenter?.sendcodegeettest4
        console.log('rest::: ', rest)
        if (rest?.success) {
          assign(this.registerInit, { requestId: rest?.requestid })
          this.verificationCode = 1
          this.switchingState = 6 // 跳转验证码
        } else {
          return this.$toast.error(rest?.extra || 'error')
        }
      } catch (err) {}
    },
    // 加密cookie
    async accessCookie (obj = {}) {
      const {
        userId = '',
        nick = '',
        showNickName = '',
        avatar = '',
        showAvataraddress = ''
      } = obj
      try {
        const {
          succeed = false,
          extra = '',
          result = {}
        } = await this.$api.login.userEncryption({
          userId,
          nick: showNickName || nick,
          avatar: showAvataraddress || avatar
        })
        if (!succeed) return this.$toast.error(extra) // 数据错误
        this.$store.commit('setVal', {
          cookieVal: result?.Value,
          simpleUser: {
            userId,
            nick: showNickName || nick,
            avatar: showAvataraddress || avatar
          }
        })
        if (this.fullDomain?.includes('wikifx'))
          this.setCookie('DJkdikKMG', result?.Value)
        else if (this.fullDomain?.includes('fxeye'))
          this.setCookie('ViLartidlakd', result?.Value)
        else {
          this.$cookies.set('WsdsfgDGdagYms', result?.Value)
          const postdata = {
            op_type: 'setCookie',
            url: '',
            parm: result?.Value
          }
          window?.parent?.postMessage(postdata, '*')
        }
        this.$emit('close')
        this.$nextTick(() => {
          location?.reload()
        })
      } catch (err) {}
    },
    // 存储cookie
    setCookie (key = '', val = '') {
      this.$cookies.set(key, val, this.$store.getters.cookConf)
    }
  }
}
